import React from 'react';

/**
 * Button - Action component
 * FLO Design System v2
 */

const variantStyles = {
  primary: 'bg-red-800 text-white border-red-900 hover:bg-red-900',
  secondary: 'bg-white text-gray-700 border-gray-300 hover:border-gray-400',
  ghost: 'bg-transparent text-gray-600 border-transparent hover:bg-gray-50'
};

const sizeStyles = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-3 py-1.5 text-sm',
  lg: 'px-4 py-2 text-sm'
};

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  className = '',
  type = 'button'
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center
        font-medium rounded-lg border
        transition-colors
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default Button;
